<template>
  <div>
    <top-message />
    <div class="bottomPart">
      <div class="titlePart">业务报送监管</div>
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane
          label="平台报送"
          name="first"
        >
          <el-form
            :inline="true"
            :model="searchForm"
            class="demo-form-inline"
          >
            <el-form-item label="统计年份">
              <el-date-picker
                :picker-options="pickerOptions"
                v-model="searchForm.year"
                type="year"
                placeholder="选择年"
                @change="handleYearChange"
                format="yyyy 年"
                value-format="yyyy"
                :editable="false"
              />
            </el-form-item>
            <el-form-item label="统计月份">
              <el-date-picker
                :picker-options="pickerMonth"
                v-model="searchForm.month"
                type="month"
                placeholder="选择月"
                @change="handleMonthChange"
                format="MM 月"
                value-format="M"
                popper-class="myMonth"
                :disabled="!searchForm.year"
                :editable="false"
              />
            </el-form-item>
            <el-form-item label="推送平台">
              <el-select
                v-model="searchForm.platform"
                placeholder="请选择"
                style="width: 100%"
                @change="handleSelectChange"
                clearable
              >
                <el-option
                  v-for="(item, index) in options"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
          </el-form>
          <el-table
            :data="tableData"
            style="width: 100%"
          >
            <el-table-column
              prop="name"
              label="平台名称"
              width="300"
            />
            <el-table-column
              prop="createTime"
              label="报送时间"
            />
            <el-table-column
              prop="isPush"
              label="是否入库"
            />
          </el-table>
        </el-tab-pane>
        <el-tab-pane
          label="银行机构报送"
          name="second"
        >
          <el-form
            :inline="true"
            :model="searchForm"
            class="demo-form-inline"
          >
            <el-form-item label="统计年份">
              <el-date-picker
                v-model="bankFrom.year"
                :picker-options="pickerOptions"
                type="year"
                placeholder="选择年"
                @change="handleYearChange"
                format="yyyy 年"
                value-format="yyyy"
                :editable="false"
              />
            </el-form-item>
            <el-form-item label="统计月份">
              <el-date-picker
                :picker-options="pickbankFrom"
                v-model="bankFrom.month"
                type="month"
                placeholder="选择月"
                @change="handleMonthChange"
                format="MM 月"
                value-format="M"
                popper-class="myMonth"
                :disabled="!bankFrom.year"
                :editable="false"
              />
            </el-form-item>
            <el-form-item label="报送机构">
              <el-select
                v-model="bankFrom.reportingAgency"
                placeholder="请选择"
                style="width: 100%"
                @change="handleSelectChange"
                clearable
              >
                <el-option
                  v-for="(item, index) in bankList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-form>
          <el-table
            :data="bankData"
            style="width: 100%"
          >
            <el-table-column
              prop="bankName"
              label="机构名称"
              width="300"
            />
            <el-table-column
              prop="createTime"
              label="报送时间"
            />
            <el-table-column
              prop="path"
              label="报送文档"
            >
              <template slot-scope="scope">
                <span
                  class="down"
                  @click="xiazai(scope.row.path)"
                >点击下载</span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import TopMessage from "@/components/TopMessage";
import baseUrl from "@/api/baseUrl";
import { platformSubmissionRecord, bank, reportedByBankingRecord, frontPageBankList, getProductType } from "@/api/statistics"
export default {
  components: { TopMessage },
  data () {
    return {
      pickerOptions: {
        disabledDate (time) {
          // return time.getTime() < Date.now() // 选当前时间之后的时间
          return time.getTime() > Date.now() // 选当前时间之前的时间
        }
      },
      pickerMonth: {
        disabledDate: time => {
          let year = this.searchForm.year
          let date = new Date().getFullYear()
          if (date > year) {
            return time.getTime() < Date.now()
          } else if (date == year) {
            return time.getTime() > Date.now()
          }
        }
      },
      pickbankFrom: {
        disabledDate: time => {
          let year = this.bankFrom.year
          let date = new Date().getFullYear()
          if (date > year) {
            return time.getTime() < Date.now()
          } else if (date == year) {
            return time.getTime() > Date.now()
          }
        }
      },
      activeName: "first",
      searchForm: {
        year: "",
        month: "",
        platform: ""
      },
      bankFrom: {
        year: "",
        month: "",
        reportingAgency: ""
      },
      tableData: [],
      bankData: [],
      options: [

      ],
      bankList: [],
      index: 0
    }

  },
  created () {
    this.getBankList()
    this.getList()
    getProductType({ code: "00601" }).then(res => {
      if (res.data.code === 200) {
        this.options = res.data.data
      }
    });
  },
  methods: {
    xiazai (e) {
      const xhr = new XMLHttpRequest();
      xhr.open("post", this.baseUrl + "/api/v1/file/downBusinessReport", true);  // get、post都可
      xhr.responseType = "blob";  // 转换流
      xhr.setRequestHeader("token", sessionStorage.getItem("token")); // token键值对
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded")
      xhr.onload = function () {
        if (this.status === 200) {
          const blob = this.response;
          const fileName = "信易贷报送文档.zip";
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            const a = document.createElement("a")
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click()
            window.URL.revokeObjectURL(url)
          }
        }
      }
      xhr.send("path=" + e);
    },
    getList () {
      platformSubmissionRecord(this.sendParam(this.searchForm)).then(res => {
        res = this.paramDecrypt(res)
        if (res.code == "200") {
          this.tableData = res.data
        }
      }).catch(err => {
      })
    },
    getBank () {
      reportedByBankingRecord(this.sendParam(this.bankFrom)).then(res => {
        res = this.paramDecrypt(res)
        if (res.code == 200) {
          this.bankData = res.data
        }

      })
    },
    getBankList () {
      let params = {}
      frontPageBankList(this.sendParam(params)).then(res => {
        res = this.paramDecrypt(res)
        if (res.code == 200) {
          this.bankList = res.data
        }
      })
    },
    handleSelectChange () {
      if (this.index == '0') {

        this.getList();
      } else if (this.index == '1') {

        this.getBank();
      }

    },
    handleClick (e) {
      this.index = e.index
      if (e.index == 0) {
        this.searchForm = {
          year: "",
          month: ""
        };
        this.getList();
      } else if (e.index == 1) {
        this.bankFrom = {
          year: "",
          month: ""
        };
        this.getBankList();
        this.getBank()
      }

    },
    handleYearChange (v) {
      if (!v) this.searchForm.month = "";
      if (!v) this.bankFrom.month = "";
      if (this.index == 0) {
        this.getList();
      } else if (this.index == 1) {
        this.getBank();
      }

    },
    handleMonthChange () {
      if (this.index == 0) {
        this.getList();
      } else if (this.index == 1) {
        this.getBank();
      }
    },
    // down (e) {
    //   window.location.href = baseUrl + e
    // }
  }
}
</script>

<style lang="less" scoped>
.bottomPart {
  width: 100%;
  min-height: 740px;
  background: #fff;
  box-sizing: border-box;
  padding: 20px 0;
  font-size: 14px;
  border-radius: 6px;
  margin-top: 20px;
  .titlePart {
    color: #2981ee;
    font-size: 24px;
    font-weight: bold;
    border-left: 6px solid #2981ee;
    padding-left: 20px;
  }
  /deep/.el-tabs {
    margin-top: 10px;
    .el-tabs__header {
      background: #f3f4f9;
      padding: 0 30px;
      .el-tabs__nav-wrap::after {
        content: unset;
      }
    }
    .el-tabs__content {
      padding: 10px 30px;
    }
  }
  /deep/.el-table thead tr th {
    background: #f3f4f9;
  }
}
/deep/.el-form {
  padding: 20px 30px 0;
  .el-date-editor {
    width: 200px;
  }
}
.down {
  cursor: pointer;
  color: #2981ee;
}
</style>